module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("The Britt Montero Series")]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Edna Buchanan")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/ContentsUnderPressure"
    }
  }, [_vm._v("Contents Under Pressure")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/MiamiItsMurder",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miami, It’s Murder")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/SuitableForFraming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suitable for Framing")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/ActOfBetrayal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Act of Betrayal")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/MarginOfError",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margin of Error")]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3787fa81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/BrittMontero.vue
// module id = 60
// module chunks = 0